import { motion } from "framer-motion";
import { Search, MapPin, Star, ChevronRight } from "lucide-react";

// Light-theme phone mockup showing the SafeRide app UI
export const PhoneMockup = () => {
  return (
    <div className="relative mx-auto w-[280px] sm:w-[300px]">
      <div className="pointer-events-none absolute -inset-10 -z-10 rounded-full bg-[#2340b5]/10 blur-3xl" />

      <div className="relative rounded-[2.6rem] border border-[#12142b]/10 bg-[#12142b] p-3 shadow-2xl shadow-[#12142b]/20">
        <div className="absolute left-1/2 top-3 z-20 h-6 w-28 -translate-x-1/2 rounded-b-2xl bg-[#12142b]" />

        <div className="relative overflow-hidden rounded-[2rem] bg-[#f4f6fb]">
          {/* Status bar */}
          <div className="flex items-center justify-between px-6 pt-4 text-[10px] font-semibold text-[#12142b]/70">
            <span>9:41</span>
            <img src="/saferide-mark.png" alt="SafeRide" className="h-4 w-auto" />
            <span>●●●</span>
          </div>

          {/* Header */}
          <div className="px-5 pt-5">
            <p className="font-display text-lg font-bold leading-tight text-[#12142b]">Where to?</p>
            <div className="mt-3 flex items-center gap-2 rounded-xl border border-[#12142b]/10 bg-white px-3 py-2.5">
              <Search className="h-4 w-4 text-[#2340b5]" strokeWidth={2} />
              <span className="text-xs text-[#565b73]">Ottawa, ON</span>
            </div>
          </div>

          {/* Ride cards */}
          <div className="mt-4 space-y-3 px-5 pb-6">
            {[
              { name: "Marcus D.", rating: "4.9", time: "08:30", price: "$24", seats: "2 seats" },
              { name: "Elena R.", rating: "5.0", time: "10:15", price: "$21", seats: "3 seats" },
              { name: "Tomás G.", rating: "4.8", time: "13:45", price: "$26", seats: "1 seat" },
            ].map((r, i) => (
              <motion.div
                key={r.name}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 + i * 0.15, duration: 0.5 }}
                className="rounded-xl border border-[#12142b]/8 bg-white p-3 shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="grid h-8 w-8 place-items-center rounded-full bg-[#2340b5] font-display text-xs font-black text-white">
                      {r.name[0]}
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-[#12142b]">{r.name}</p>
                      <p className="flex items-center gap-1 text-[10px] text-[#565b73]">
                        <Star className="h-2.5 w-2.5 fill-[#fdb913] text-[#fdb913]" /> {r.rating}
                      </p>
                    </div>
                  </div>
                  <span className="font-display text-sm font-bold text-[#2340b5]">{r.price}</span>
                </div>
                <div className="mt-2.5 flex items-center justify-between border-t border-[#12142b]/8 pt-2.5 text-[10px] text-[#565b73]">
                  <span className="flex items-center gap-1">
                    <MapPin className="h-3 w-3" strokeWidth={2} /> Dep. {r.time}
                  </span>
                  <span>{r.seats}</span>
                  <ChevronRight className="h-3 w-3 text-[#2340b5]" />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
